import React, {Component} from 'react';
import {DataGrid} from "../../components/ui/DataGrid";
import {FontAwesomeIcon} from "../../components/ui/FontAwesomeIcon";



export class HierarchyNavigation extends Component<IHierarchyNavigationProps, containerState> {

  renderHierarchyColumn(avid: IAvid) {
    const {updateCurrentAvid, AvidsList} = this.props;
    let isSelected = false;
    const avidFromList = this.props.AvidsList.find((avidFromList) => avidFromList.id == avid.id);
    if (avidFromList) {
      isSelected = avidFromList.state.selected;
    }
    if (avid.childCount) {
      return (
        <>
          <FontAwesomeIcon icon={(isSelected ? "check-square" : "square")} verticalAlign="initial" size="lg" regular onClick={() => this.props.toggleSelectAvid(avid.id)} style={{cursor: 'pointer'}}/>
          <a href='#' className="id-wrapper" onClick={() => {
            updateCurrentAvid({avid: avid, label: avid.text});
          }}>
            <span>&nbsp;{avid.text}</span>
          </a>
        </>
      );
    } else return (
      <><FontAwesomeIcon icon={(isSelected ? "check-square" : "square")} verticalAlign="initial" size="lg" regular onClick={() => this.props.toggleSelectAvid(avid.id)} style={{cursor: 'pointer'}}/><span>&nbsp;{avid.text}</span></>
    );
  }

  renderHasGranularAssigment(childCount: number) {
    return (
      <>{(childCount ? 'YES' : 'NO')}</>
    );
  }

  renderDefaultColumn(avid: IAvid) {
    if(avid.isDefault)
      return(
        <FontAwesomeIcon icon="star" verticalAlign="initial" size="md"/>
      );
    else return(
      <FontAwesomeIcon icon="star" verticalAlign="initial" size="md" regular onClick={() => this.props.setDefaultAvid(avid)} style={{cursor: 'pointer'}}/>
    );
  }

  render() {
    const {trail, childAvids, updateCurrentAvid} = this.props;
    return (
      <div id='hierarchyGranularAssigmentComponent'>
        <header className='d-flex'>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              {trail.map((node, idx) => {
                return (<li className="breadcrumb-item" aria-current="page" key={idx} onClick={() => {updateCurrentAvid(node)}}>{node.label}</li>);
              })}
            </ol>
          </nav>
        </header>
        <DataGrid<IAvid>
          records={childAvids}
          columns={[
            { header: 'Hierarchy', sortable: false, render: (avid) => this.renderHierarchyColumn(avid) },
            { header: 'Default', sortable: false, render: (avid) => this.renderDefaultColumn(avid), align: 'center' },
          ]}
        />
      </div>
    );
  }
}